import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { ManageEquipmentService } from '../manage-equipment.service';
import { EquipmentCompartmentTypeModel } from '../models/manage-equipment.model';
import { PercentWornCalculationMethod } from '../../../../app/shared/enums/allEnums';

@Component({
  selector: 'app-avg-worn-calculation-pop-up',
  templateUrl: './avg-worn-calculation-pop-up.component.html',
  styleUrls: ['./avg-worn-calculation-pop-up.component.scss']
})
export class AvgWornCalculationPopUpComponent implements OnInit {

  EquipmentId: number;
  EquipmentCompartmentTypeModel: EquipmentCompartmentTypeModel[] = [];
  worstComponent: boolean = false;
  averagePercent: boolean = false;
  constructor(public dialogRef: MatDialogRef<AvgWornCalculationPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any, private _notify: NotificationsService, private _equipmentService: ManageEquipmentService,) { }

  ngOnInit(): void {
    this.EquipmentId = this._data.EquipmentId;
    this.getEquipmentCompartTypes();

  }
  getEquipmentCompartTypes() {
    this._equipmentService.GetEquipmentCompartmentTypes(this.EquipmentId).subscribe(res => {
      this.EquipmentCompartmentTypeModel = res;
       this.EquipmentCompartmentTypeModel.forEach(item => {
        if (item.IsSelected) {
          this.selectedComponentTypeIds.push(item.CompartTypeId);
        }
      });
     
      if (this.EquipmentCompartmentTypeModel[0].PercentWornCalMethod == 'AverageComponents') {
        this.averagePercent = true;
        this.worstComponent = false;
      } else {
        this.worstComponent = true;
        this.averagePercent = false;
      }
    });
  }
  onNoClick() {
    this.dialogRef.close(true);
  }

  onWorstComponentChange() {
    if (this.worstComponent) {
      this.averagePercent = false;
      // this.resetComponents();
    }
  }

  onAveragePercentChange() {
    if (this.averagePercent) {
      this.worstComponent = false;
    } else {
      //this.resetComponents();
    }
  }
  selectedComponentTypeIds: number[] = [];
  isComponentSelected(componentTypeId: number): boolean {
    return this.selectedComponentTypeIds.includes(componentTypeId);
  }

  onComponentChange(comparttypeId: number, checked: boolean) {
    if (checked) {
      this.selectedComponentTypeIds.push(comparttypeId);
    } else {
      this.selectedComponentTypeIds =
        this.selectedComponentTypeIds.filter(id => id !== comparttypeId);
    }
  }

  savePercentWornPreference() {

    if (!this.worstComponent && !this.averagePercent) {
      this._notify.warn('Error', 'Please select Worst or Average');
      return;
    }

    if (this.averagePercent && this.selectedComponentTypeIds.length === 0) {
      this._notify.warn('Error', 'Select at least one component for Average % Worn');
      return;
    }

    const payload = {
      equipmentId: this.EquipmentId,
      isWorstSelected: this.worstComponent,
      isAverageSelected: this.averagePercent,
      componentTypeIds: this.selectedComponentTypeIds.join(',')
    };

    this._equipmentService.SavePercentWornPreference(payload)
      .subscribe({
        next: () => {
          this.onNoClick();
          this._notify.success('Success', 'Percent worn preference saved successfully');
        },
        error: err => {
          console.error('Save failed', err);
        }
      });
  }
  // EquipmentPercentWornPreferenceDto : EquipmentPercentWornPreferenceDto;
  //  GetPercentWornPreference() {
  //     this._equipmentService.GetPercentWornPreference(this.EquipmentId).subscribe(res => {
  //       this.EquipmentPercentWornPreferenceDto = res;
  //     });
  //   }
}